// extracted by mini-css-extract-plugin
export default {"searchInput":"theme_searchInput__US4Ar"};